import React, { useEffect, useRef, useState } from "react";
import InterviewAnalysisFirstSec from "./interviewComponent/InterviewAnalysisFirstSec";
import Navbar from "./Navbar";
import Footer from "../Footer";
import InterviewAnalysisSecondSec from "./interviewComponent/InterviewAnalysisSecondSec";
import InterviewOrientation from "./interviewComponent/InterviewOrientation";
import { useLocation } from "react-router-dom";
import WebUtils from "../utils/WebUtils";
import {
  getSusAppsApi,
  interviewAnalysisConfigurationGetAPi,
  interviewAnalysisCountAPi,
  interviewAnalysisGetAPi,
  interviewAnalyticsTimingGetAPi,
  reportValidatePostApi,
} from "../../api";
import { Button, Form, Input, Modal, Popover, Spin } from "antd";
import Loader from "../Loader";
import Utils from "../utils/Utils";
import "../../styles/interviewAnalysis.css";

function InterviewAnalysisMain() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loginQuery = queryParams.get("q");

  const tab = queryParams.get("tab");

  console.log(tab);

  const decodeValidate = (value) => {
    if (value === null) {
      return null;
    }
    try {
      return atob(value);
    } catch (error) {
      // console.error("Failed to decode login query:", error);
      return null; // Or handle it in a way that suits your application
    }
  };
  let decodedLoginQuery = decodeValidate(loginQuery);
  //   console.log(decodedLoginQuery);

  const params = {};
  if (decodedLoginQuery) {
    const paramsArray = decodedLoginQuery.split("&");

    paramsArray.forEach((param) => {
      const [key, value] = param.split("=");
      params[key] = value;
    });
  }

  const interviewId = params.interviewId;
  const passcode = params.passcode;
  const userRole = params.userRole;
  const interviewType = params.interviewType;

  const [passvarified, setPassVarified] = useState(null);
  const [passText, setPassText] = useState(passcode);
  const [interviewIdText, setInterviewIdText] = useState(interviewId);
  const [passModal, setPassModal] = useState(true);
  const [passcodeError, setPassCodeError] = useState();
  const [interviewAnalysisData, setInterviewAnalysisData] = useState(null);
  const [interviewAnalysisDataConfig, setInterviewAnalysisDataConfig] =
    useState(null);
  const [analysisData, setAnalysisData] = useState(null);
  const [config, setConfig] = useState(null);
  const [interviewIdError, setInterviewIdError] = useState();
  const [accessTokenAuth, setAccessTokenAuth] = useState();
  const [loading, setLoading] = useState(false);
  const [jdLevelData, setJdLevelData] = useState(null);
  const [windowsSusAppData, setWindowsSusAppData] = useState([]);
  const [macSusAppData, setMacSusAppData] = useState([]);

  const passVarifyFunc = (ip) => {
    setLoading(true);
    let reqCount = {
      role: "",
      name: "",
      osType: Utils.detectOS(),
      osVersion: Utils.getOSVersion(),
      browserType: Utils.browserCheck(),
      browserVersion: Utils.browserVersionCheck(),
      ipAddress: ip,
      systemSpecs: {},
      dateTimeInfo: new Date().toISOString().slice(0, -5),
      logCode: "Interview video",
      logMessage: "Interview video count done",
    };
    // console.log(reqCount);
    if (!interviewIdText || !passText || !interviewType) {
      setLoading(false);
      setPassCodeError("Invalid parameters");
    } else {
      let url = `${reportValidatePostApi}?interviewId=${interviewIdText}&interviewPasscode=${passText}&interviewType=${interviewType}`;
      WebUtils.httpOperations(url, {}, "POST", true)
        .then((result) => {
          if (
            result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
          ) {
            //   console.log(result);
            setPassModal(false);
            setPassVarified(true);
            // setAccessTokenAuth(result.data.data.accessToken);
            getInterviewAnalysis(result.data.data.accessToken);
            getInterviewAnalysisConfi(result.data.data.accessToken);
            countApi(result.data.data.accessToken, reqCount);
            getSuspiciousAppsWindows();
            getSuspiciousAppsMac();
          } else if (
            result.data.resultStatusInfo.resultCode === "UNAUTHORIZED"
          ) {
            setPassCodeError("Invalid passcode or InterviewId");
            // setInterviewIdError("Invalid InterviewId")
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  const getInterviewAnalysis = async (auth) => {
    const url = `${interviewAnalysisGetAPi}?interviewId=${interviewId}&interviewType=${interviewType}`;
    // let url
    try {
      setLoading(true);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        // console.log(result.data);
        setInterviewAnalysisData(result.data);
        // fetchAnalysisData(result.data.headPoseUrl);
        // if (result.data.headPoseUrl) {
        // }
        fetch(result.data.facialAnalysisUrl, {
          method: "GET",
          headers: {
            // Uncomment or add any headers required by the API
            // 'Authorization': `Bearer ${auth}`
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            // console.log(data);
            setAnalysisData(data);
          })
          .catch((error) => {
            console.error("Fetch error:", error);
          });
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false);
    }
  };

  const getInterviewAnalyticsTiming = async (auth, jdId) => {
    const url = `${interviewAnalyticsTimingGetAPi}?jdId=${jdId}`;
    // let url
    try {
      setLoading(true);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        setJdLevelData(result.data);
        // setInterviewAnalysisData(result.data);
        // fetchAnalysisData(result.data.headPoseUrl);
        // if (result.data.headPoseUrl) {
        // }
        fetch(result.data.facialAnalysisUrl, {
          method: "GET",
          headers: {
            // Uncomment or add any headers required by the API
            // 'Authorization': `Bearer ${auth}`
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            // console.log(data);
            setAnalysisData(data);
          })
          .catch((error) => {
            console.error("Fetch error:", error);
          });
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false);
    }
  };

  const getInterviewAnalysisConfi = async (auth) => {
    const url = `${interviewAnalysisConfigurationGetAPi}?interviewId=${interviewId}`;
    // let url
    try {
      setLoading(true);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        setInterviewAnalysisDataConfig(result.data);
        setConfig(result.data?.configuration);
        getInterviewAnalyticsTiming(auth, result?.data?.jdIdentifier);
      }
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      setLoading(false);
    }
  };

  const countApi = async (auth, reqbody) => {
    const url = `${interviewAnalysisCountAPi}?interviewId=${interviewId}`;
    // let url
    try {
      // setLoading(true);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
        body: JSON.stringify(reqbody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      // setLoading(false);
    }
  };

  const getSuspiciousAppsWindows = async () => {
    try {
      const response = await fetch(`${getSusAppsApi}?osType=WINDOWS`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "exdsfrty7365378TerdstAIOP!@123",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch suspicious apps");
      }

      const data = await response.json();
      setWindowsSusAppData(data?.data || []);

      return data;
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const getSuspiciousAppsMac = async () => {
    try {
      let url = `${getSusAppsApi}?osType=MAC_OS`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "exdsfrty7365378TerdstAIOP!@123",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch suspicious apps");
      }

      const data = await response.json();
      setMacSusAppData(data?.data || []);

      return data;
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        passVarifyFunc(data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);

  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);

  const updateVideoTrack = (value) => {
    if (videoRef.current?.currentTime) {
      setCurrentTime(value);
      videoRef.current.currentTime = value;
    }
  };
  return (
    <>
      {passvarified ? (
        <div className="flex flex-col justify-between min-h-screen items-center w-full ">
          <Navbar config={config} />
          <div className="md:px-6 xl:px-10 px-3 w-full">
            <InterviewAnalysisFirstSec
              interviewAnalysisDataConfig={interviewAnalysisDataConfig}
            />
            <InterviewAnalysisSecondSec
              videoRef={videoRef}
              currentTime={currentTime}
              updateVideoTrack={updateVideoTrack}
              interviewAnalysisData={interviewAnalysisData}
              analysisData={analysisData}
              interviewAnalysisDataConfig={interviewAnalysisDataConfig}
            />
            <InterviewOrientation
              updateVideoTrack={updateVideoTrack}
              analysisData={analysisData}
              interviewAnalysisIntegrityData={
                interviewAnalysisData?.integrityInfo
              }
              mbtiAnalysisData={interviewAnalysisData?.mbtiAnalysis}
              jdLevelData={jdLevelData}
              config={config}
              windowsSusAppData={windowsSusAppData}
              macSusAppData={macSusAppData}
              tab={tab}
            />
          </div>
          <div className="px-5 w-full pb-2 mt-12">
            <Footer />
          </div>
        </div>
      ) : (
        <>
          {loading && <Loader />}
          <div className=" login-landing-page min-h-screen bg-primaryBg ">
            <Modal
              //   title={<p className=" text-lg">Interview ID : {interviewId}</p>}
              open={passModal}
              centered
              footer={null}
              size="sm"
              closable={false}
              style={{ borderRadius: 8 }}
              className="custom-modal rounded"
            >
              {/* <Modal.Body> */}
              <div className=" w-75 m-auto">
                <Form layout="vertical" onFinish={passVarifyFunc}>
                  <Form.Item
                    tooltip="InterviewId is required"
                    label="InterviewId"
                    name="interviewId"
                    initialValue={interviewId} // Set initial value from state or prop
                    rules={[
                      {
                        required: true,
                        message: "Please enter your InterviewId",
                      },
                    ]}
                  >
                    <Input
                      value={interviewIdText}
                      className="rounded"
                      onChange={(e) => {
                        setInterviewIdText(e.target.value);
                        setPassCodeError("");
                      }}
                    />
                    {/* <p className="p-0 m-0" style={{ color: "red" }}>
                  {passcodeError}
                </p> */}
                  </Form.Item>
                  <Form.Item
                    tooltip="Passcode is required"
                    label="Passcode"
                    name="passcode"
                    initialValue={passcode} // Set initial value from state or prop
                    rules={[
                      {
                        required: true,
                        message: "Please enter your passcode",
                      },
                    ]}
                  >
                    <Input.Password
                      value={passText}
                      className="rounded"
                      onChange={(e) => {
                        setPassText(e.target.value);
                        setPassCodeError("");
                      }}
                    />
                    <p className="p-0 m-0" style={{ color: "red" }}>
                      {passcodeError}
                    </p>
                  </Form.Item>
                  <div className="flex justify-center items-center py-1 mt-2">
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={!passText} // Simplified conditional
                    >
                      View Report
                    </Button>
                  </div>
                </Form>
              </div>
              {/* </Modal.Body> */}
            </Modal>
          </div>
        </>
      )}
    </>
  );
}

export default InterviewAnalysisMain;
